export const statusKeys = [
  'starter',
  'bronze',
  'silver',
  'gold',
  'platinum',
  'diamond',
  'master',
  'grandmaster',
  'champion',
  'legend',
] as const;
